<table
  mat-table
  [dataSource]="dataSource"
  matSort
  matPaginator>
  <ng-container matColumnDef="identity">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      Audit Title
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      {{ row.identity }}
    </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      Recommendation Title
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      {{ row.title }}
    </td>
  </ng-container>

  <ng-container matColumnDef="priority">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      Priority
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      {{ row.priority }}
    </td>
  </ng-container>

  <ng-container matColumnDef="deadline">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      Deadline
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      {{ row.deadline | date : 'dd.MM.yyyy' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="auditor">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      Audit Dep.
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      {{ row.auditor }}
    </td>
  </ng-container>

  <ng-container matColumnDef="remark">
    <th
      mat-header-cell
      *matHeaderCellDef>
      Remark
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      <span [innerHTML]="row.shortRemtoAss | userReplace"></span>
    </td>
  </ng-container>

  <ng-container matColumnDef="createdBy">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header>
      Auditor
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      {{ row.createdBy | userName | async }} {{ row.createdBy | azureIdStatus | async }}
    </td>
  </ng-container>

  <ng-container matColumnDef="auditee">
    <th
      mat-header-cell
      *matHeaderCellDef>
      Auditee
    </th>
    <td
      mat-cell
      *matCellDef="let row">
      {{ row.assessmentCoordinator | userName: row.assessmentCoordinatorName | async }}
      {{ row.assessmentCoordinator | azureIdStatus | async }}
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    (click)="navigateTo(row)"
    class="clickable-row"></tr>
</table>

<mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" />
